module.exports = __webpack_public_path__ + "static/img/62-1.f0b8d33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/62-1.jpg
// module id = gPu7
// module chunks = 0